export { default } from './dist/vue-mouse-parallax.common'
export * from './dist/vue-mouse-parallax.common'
import './dist/vue-mouse-parallax.css'
